import { useState } from 'react'
import PropTypes from 'prop-types'


const CheckboxField = ({value, name, text, valid, valid_reg, setCheckValue, setAddress, trigger}) => {
  const toggle = (ev) => {
    setCheckValue(name, !value, !value, !value)
  }

  return (
    <label 
      className="checkbox"
      valid={value ? 'true' : 'false'}
      error={!value && trigger ? 'true' : 'false'}
      onClick={toggle}
    >
      <span className={value ? "checkbox-field__check checkbox-field__check_checked" : "checkbox-field__check"}></span>
      <span dangerouslySetInnerHTML={{ __html: text}} />
    </label>
  )

}

CheckboxField.propTypes = {
  value: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  valid_reg: PropTypes.bool.isRequired,
  setCheckValue: PropTypes.func.isRequired,
  trigger: PropTypes.bool.isRequired,
}


export default CheckboxField